var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreviousSlotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70492 10.59L3.12492 6L7.70492 1.41L6.29492 0L0.294922 6L6.29492 12L7.70492 10.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousSlotIcon);
export default __webpack_public_path__ + "static/media/previous-slot-icon.e821bf6fd08821cdb97237b1d43eb23f.svg";
export { ForwardRef as ReactComponent };